import {
  LayoutDashboard, Users, Wallet, ArrowDownToLine, ArrowUpFromLine, BookOpen,
  CreditCard, Dice5, ListChecks, Radio, Gift, Crown, ShoppingBag, Share2,
  Images, Megaphone, Headphones, Settings, ScrollText, ShieldCheck, BarChart3,
  Flag, Languages, AlertTriangle, Activity, TrendingUp, FileCheck, LifeBuoy,
  Boxes,
  type LucideIcon,
} from 'lucide-react';
import type { Capability } from '@/lib/auth/rbac';

export interface NavItem {
  label: string;
  to: string;
  icon: LucideIcon;
  /** Capability required to even see the item (read screens omit this). */
  capability?: Capability;
  /** Only SUPER_ADMIN sees super-only items. */
  superOnly?: boolean;
  /** Route not yet implemented — shown disabled with a "Soon" tag. */
  soon?: boolean;
  end?: boolean;
}

export interface NavSection {
  title: string;
  items: NavItem[];
}

export const NAV: NavSection[] = [
  {
    title: 'Overview',
    items: [
      { label: 'Dashboard', to: '/', icon: LayoutDashboard, end: true },
      { label: 'Analytics', to: '/analytics', icon: BarChart3 },
    ],
  },
  {
    title: 'Players',
    items: [
      { label: 'Members', to: '/users', icon: Users },
    ],
  },
  {
    title: 'Finance',
    items: [
      { label: 'Recharges', to: '/finance/recharges', icon: ArrowDownToLine, capability: 'finance.read' },
      { label: 'Withdrawals', to: '/finance/withdrawals', icon: ArrowUpFromLine, capability: 'finance.read' },
      { label: 'Ledger', to: '/finance/ledger', icon: BookOpen, capability: 'ledger.read' },
      { label: 'Payment Methods', to: '/finance/methods', icon: CreditCard },
      { label: 'Reconciliation', to: '/finance/reconciliation', icon: Wallet, capability: 'ledger.read' },
    ],
  },
  {
    title: 'Games',
    items: [
      { label: 'Live Control Room', to: '/games/control-room', icon: Radio, soon: true },
      { label: 'Bets', to: '/games/bets', icon: Dice5 },
      { label: 'Issues & Draws', to: '/games/issues', icon: ListChecks },
      { label: 'Games & Odds', to: '/games/odds', icon: Activity },
      { label: 'Game P&L', to: '/games/pnl', icon: TrendingUp },
      { label: 'Providers', to: '/games/providers', icon: Boxes },
    ],
  },
  {
    title: 'Engagement',
    items: [
      { label: 'Activities', to: '/engagement/activities', icon: Gift },
      { label: 'VIP Tiers', to: '/engagement/vip', icon: Crown },
      { label: 'Point Mall', to: '/engagement/point-mall', icon: ShoppingBag },
      { label: 'Affiliates', to: '/engagement/affiliates', icon: Share2 },
    ],
  },
  {
    title: 'Content',
    items: [
      { label: 'Banners', to: '/content/banners', icon: Images },
      { label: 'Notices', to: '/content/notices', icon: Megaphone },
      { label: 'Customer Service', to: '/content/customer-service', icon: Headphones },
      { label: 'Site Settings', to: '/content/settings', icon: Settings },
    ],
  },
  {
    title: 'Compliance',
    items: [
      { label: 'KYC / Verification', to: '/compliance/kyc', icon: FileCheck },
      { label: 'Responsible Gambling', to: '/compliance/responsible-gambling', icon: LifeBuoy },
      { label: 'Risk & AML', to: '/risk', icon: AlertTriangle },
    ],
  },
  {
    title: 'Governance',
    items: [
      { label: 'Audit Log', to: '/audit', icon: ScrollText },
      { label: 'Admin Users', to: '/admins', icon: ShieldCheck, superOnly: true },
      { label: 'Feature Flags', to: '/platform/flags', icon: Flag, soon: true },
      { label: 'Localization', to: '/platform/i18n', icon: Languages, soon: true },
    ],
  },
];
